export function showToast(vm, { text, status = "success", duration = 3000 }) {
  if (vm && vm.$toast && vm.$toast[status]) {
    vm.$toast[status](text, {
      position: "top-right",
      duration,
    });
  } else {
    console.warn("Toast not available", { vm, text, status });
  }
}
